import { render, staticRenderFns } from "./UserMockTests.vue?vue&type=template&id=9c603966&scoped=true&"
import script from "./UserMockTests.vue?vue&type=script&lang=js&"
export * from "./UserMockTests.vue?vue&type=script&lang=js&"
import style0 from "./UserMockTests.vue?vue&type=style&index=0&id=9c603966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c603966",
  null
  
)

export default component.exports